import {Message} from 'element-ui'
let msgIns = null;
const resetMsg = (options) => {
    if (msgIns && !options.offset){//如果有偏移量不关闭，同时开多个
        msgIns.close();
    }
    //msgIns = Message(options)
    msgIns = Message({ offset: 80,...options})
  };

  ['success', 'warning', 'info', 'error'].forEach(type => {
    resetMsg[type] = options => {
      if (typeof options === 'string') {
        options = {message: options,};
      }
      options.type = type;
      return resetMsg(options);
    };
  });
  export const message = resetMsg


  


// WEBPACK FOOTER //
// ./src/utils/msg.js